// extracted by mini-css-extract-plugin
module.exports = {"tabcard":"ContactGroup_tabcard__1Q05W","active":"ContactGroup_active__1e7ws"};